/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a US ton the same as a metric tonne?`)
};

const es_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Una tonelada estadounidense es igual a una tonelada métrica?`)
};

const de_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine US-Tonne dasselbe wie eine metrische Tonne?`)
};

const nl_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een Amerikaanse ton hetzelfde als een metrieke tonne?`)
};

const fr_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une tonne américaine est-elle la même qu'une tonne métrique ?`)
};

const it_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una tonnellata USA è la stessa di una tonnellata metrica?`)
};

const pt_br2_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma tonelada US é a mesma que uma tonelada métrica?`)
};

const pt_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma tonelada americana é igual a uma tonelada métrica?`)
};

const ja_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米国トンはメートルトンと同じですか?`)
};

const zh_uc_wt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq2_q", locale)
	if (locale === "en") return en_uc_wt_faq2_q(inputs)
	if (locale === "es") return es_uc_wt_faq2_q(inputs)
	if (locale === "de") return de_uc_wt_faq2_q(inputs)
	if (locale === "nl") return nl_uc_wt_faq2_q(inputs)
	if (locale === "fr") return fr_uc_wt_faq2_q(inputs)
	if (locale === "it") return it_uc_wt_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq2_q(inputs)
	if (locale === "pt") return pt_uc_wt_faq2_q(inputs)
	if (locale === "ja") return ja_uc_wt_faq2_q(inputs)
	return zh_uc_wt_faq2_q(inputs)
};